
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'FlowAddButton',
  props: {
    top: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
    closureMode: {
      type: Boolean,
      default: false,
    },
    closureSelectable: {
      type: Boolean,
      default: false,
    },
    closureSelected: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  setup(props) {
    const buttonStyle = computed(() => ({
      top: `${props.top}px`,
      left: `${props.left}px`,
    }));

    return {
      buttonStyle,
    };
  },
});
